const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },
  landingPageRoot: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
  },
  editor: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
  tab: {
    display: 'flex',
    padding: '10px 32px',
    justifyContent: 'center',
    alignItems: 'flex-end',
    gap: '12px',
    alignSelf: 'stretch',
    width: '100%',
    borderBottom: '1px solid var(--mcg-bg, #F4F6F8)',
  },
  tabShort: {
    display: 'flex',
    padding: '10px 32px 10px 88px',
    justifyContent: 'center',
    alignItems: 'flex-end',
    gap: '12px',
    alignSelf: 'stretch',
    width: '100%',
    borderBottom: '1px solid var(--mcg-bg, #F4F6F8)',
  },
  tabLong: {
    display: 'flex',
    padding: '10px 32px 10px 312px',
    justifyContent: 'center',
    alignItems: 'flex-end',
    gap: '12px',
    alignSelf: 'stretch',
    borderBottom: '1px solid var(--mcg-bg, #F4F6F8)',
  },
})
export default styles
